<template>
  <div class="text-center ed-bg full-screen">
    <form class="form-signin">
      <a href="http://www.cambialefacile.it">
        <img class="mt-3 mb-3" src="../../assets/logo-cambialefacile_200-36.png">
      </a>
      <h1 class="h6 mb-3 font-weight-normal">Crea il tuo account, è gratis!</h1>

      <label for="inputEmail" class="sr-only">E-mail</label>
      <input type="email" id="inputEmail" class="form-control" placeholder="E-mail" v-model="user.email" autofocus>
      <label for="phone" class="sr-only">Telefono</label>
      <input type="search" autocomplete="off" id="phone" class="form-control" placeholder="Telefono"
             v-model="user.phone">

      <label for="inputPassword" class="sr-only">Password</label>
      <input type="password" id="inputPassword" class="form-control" placeholder="Password"
             v-model="user.plainPassword">

      <div v-if="error!=''" class="alert alert-danger" role="alert">
        {{ error }}
      </div>
      <button class="btn btn-lg btn-success btn-block" type="submit" @click.prevent="register()">Registrati</button>
      <p class="mt-4 mb-3 text-muted"> Sei già registrato?</p>

      <!-- <b-button to="/login" block variant="btn btn-lg btn-light font-primary-ed">Accedi</b-button> -->
      <router-link to="/login" class="btn btn-lg btn-light btn-block ">Accedi
      </router-link>
    </form>
    <p class="mt-5 mb-3 text-muted text-center"> all &copy; cambialefacile 2015-2019 </p>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from 'axios'

export default {
  name: 'Register',
  components: {},
  data: function () {
    return {
      user: {
        email: '',
        plainPassword: '',
        phone: ''
      },
      error: ''
    }
  },
  mounted: function () {
    //al caricamento della pagina
  },
  computed: {},
  methods: {
    register: function () {
      var $vm = this

      $vm.error = ''
      var user = JSON.parse(JSON.stringify($vm.user))

      if ($vm.user.phone == '' || $vm.user.plainPassword == '' || $vm.user.phone == '') {
        $vm.error = 'Compila tutti i campi'
        return false
      }
      user.username = user.email

      axios.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/user',
          user
      ).then(function (response) {

        axios.post(process.env.VUE_APP_API_BASE_URL + '/api/v1/amortization/create-default', {
          user_id: response.data.id
        }).then(function (response) {
          $vm.$router.push({name: 'register-success'})
        })

      }).catch(function (err) {
        if (err.response.status == 409) {
          $vm.error = 'Utente già esistente'
        } else {
          $vm.error = 'Errore del server'
        }

      })

    }
  }
}
</script>

<style scoped>

/* // input[type="checkbox"]{
//     outline:2px solid red;
//     outline-offset: -2px;
// } */
.full-screen {
  height: 100vh;
}

.custom-control-input {
  background-color: red;
}

/* :checked.custom-control-indicator  */

.ed-bg {
  background-color: #272F44;
  background-color: #222939;
  color: white;
}

.font-primary-ed {
  color: #3A9275 !important;
}

/* preso da bootstrap */

.form-signin {
  width: 100%;
  max-width: 330px;
  padding: 15px;
  margin: 0 auto;
}

.form-signin .checkbox {
  font-weight: 400;
}

.form-signin .form-control {
  position: relative;
  box-sizing: border-box;
  height: auto;
  padding: 10px;
  font-size: 16px;
}

.form-signin .form-control:focus {
  z-index: 2;
}

.form-signin input[type="email"] {
  margin-bottom: -1px;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.form-signin input[type="password"] {
  margin-bottom: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}


/* checkbox */
.container {
  display: block;
  position: relative;
  padding-left: 35px;

  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;

  /*cuper*/
  text-align: left;
  padding-left: 42px !important;
}

@media (min-width: 768px) {
  .container {
    max-width: 720px;
    padding-left: 40px;
  }
}


/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  position: absolute;
  margin-top: 10;
  top: 0;
  left: 0;
  height: 25px;
  width: 25px;
  background-color: #eee;
  margin-top: 3px;
}


/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: #ccc;
  background-color: white;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: #3A9275;

}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 9px;
  left: 10px;
  top: 5px;
  top: 7px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 3px 3px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}
</style>
